<script>
import {
  ActionBar,
  ActionBarTitle,
  //ActionBarButton
} from '@/components/ui/action-bar'
import { PageContainer } from '@/components/page/page-container'
import { AppContainer } from '@/components/ui/container'
import { IncomeExpenseService } from '@/services'
import { useLoading } from '@/use/loading'
import { back } from '@/utils/navigation'

const Form = () => import('../components/Form')

export default {
  created() {
    addEventListener('beforeunload', this.handleBeforeunload)
  },

  beforeDestroy() {
    removeEventListener('beforeunload', this.handleBeforeunload)
  },

  methods: {
    cancel() {
      back({ name: 'IncomeExpense' })
    },

    async save() {
      try {
        const form = await this.$refs.form.submit()

        const loading = useLoading()

        try {
          const {
            data: { status }
          } = await IncomeExpenseService.createIncome({
            income_expense_type: form.type.id,
            amount: form.amount,
            datetime: form.datetime,
            description: form.description,
            attachments: form.evidences.map(item => item.id),
            note: form.note
          })

          if (status === 'error')
            throw new Error('เกิดข้อผิดพลาดในการส่งข้อมูล')

          this.$notify.success('บันทึกข้อมูลเรียบร้อย')

          back({ name: 'IncomeExpense' })
        } catch (err) {
          this.$notify.error(err.message)
        } finally {
          loading.close()
        }
      } catch (err) {
        this.$message.warning('กรุณากรอกข้อมูลให้ครบถ้วนและถูกต้อง')
      }
    },

    handleBeforeunload(e) {
      e.preventDefault()
      e.returnValue = ''
    }
  },

  render() {
    return (
      <div>
        <ActionBar>
          <el-button slot="action" type="danger" onClick={this.cancel}>
            ยกเลิก
          </el-button>
          <el-button slot="action" type="primary" onClick={this.save}>
            บันทึก
          </el-button>
          <ActionBarTitle>บันทึกรายรับ</ActionBarTitle>
        </ActionBar>
        <PageContainer>
          <AppContainer>
            <h1>รายรับ</h1>
            <Form ref="form" />
          </AppContainer>
        </PageContainer>
      </div>
    )
  }
}
</script>
